module.exports = __webpack_public_path__ + "img/canvas.b33c6263.png";